// initial state
const state = {
  loading: false,
};

// getters
const getters = {
  loading: currentState => currentState.loading,
};

// actions
const actions = {
  showLoader({ commit }) {
    commit('setLoading', { loading: true });
  },
  hideLoader({ commit }) {
    commit('setLoading', { loading: false });
  },
};

// mutations
const mutations = {
  setLoading(currentState, { loading }) {
    currentState.loading = loading;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/general.js